var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-textarea',{attrs:{"background-color":"light-blue","color":"black","label":"Label"}}),_c('v-textarea',{attrs:{"background-color":"grey lighten-2","color":"cyan","label":"Label"}}),_c('v-textarea',{attrs:{"background-color":"amber lighten-4","color":"orange orange-darken-4","label":"Label"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }